import styles from './StatusIndicator.module.css';

type StatusType =
	| 'running'
	| 'active'
	| 'paused'
	| 'draft'
	| 'completed'
	| 'inactive'
	| 'error'
	| 'revoked';

interface StatusIndicatorProps {
	status: StatusType;
	label?: string;
}

export function StatusIndicator({ status, label }: StatusIndicatorProps) {
	const displayLabel = label ?? status;
	const statusClass = styles[status] ?? styles.inactive;

	return (
		<span className={[styles.status, statusClass].join(' ')}>
			<span className={styles.statusDot} />
			{displayLabel}
		</span>
	);
}
